import { GET_SYSTEM_LOG } from "../actions/types";

const initialState = { SystemLogList: [] };

const SystemLogReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_SYSTEM_LOG:
      return {
        ...state,
        SystemLogList: payload,
      };
    default:
      return state;
  }
};

export { SystemLogReducer };
